import * as Yup from "yup";
import { setDroneData } from "./utils/setDroneData";

const isAnyDroneComplete = (drones = []) =>
  drones.some(
    (d) =>
      d.type?.trim() &&
      d.status?.trim() &&
      d.droneId?.trim() &&
      d.drone_ip?.trim() &&
      d.device_id?.trim(),
  );
const isAnyDroneFilledPartially = (drones = []) =>
  drones.some(
    (d) =>
      d.type?.trim() ||
      d.droneId?.trim() ||
      d.drone_ip?.trim() ||
      d.device_id?.trim(),
  );
const isAnyDroneFieldFilled = (drone = {}) =>
  Object.values(drone).some((v) => v?.trim());

const getFields = (drones, index) => {
  const { status, type, droneId, drone_ip, device_id } = drones[index] || {};
  return { fields: { type, droneId, drone_ip, device_id }, status };
};

function droneFieldRequired(keyName) {
  return function (drone) {
    const value = drone ? drone[keyName] : undefined;
    // const drones = this.parent?.parent;
    const drones = this.parent;

    if (!Array.isArray(drones)) return true;

    const index = drones.indexOf(drone);

    const anyComplete = isAnyDroneComplete(drones);

    const { fields, status } = getFields(drones, index);
    const rowTouched = isAnyDroneFieldFilled(fields);

    // CASE 1: Any drone complete → validate only touched rows
    if (anyComplete) {
      if (rowTouched && !value?.trim()) {
        return this.createError({
          path: `drones[${index}].${keyName}`,
          // message: `${keyName.replace("_", " ")} is required`,
        });
      }
      return true;
    }

    // CASE 2: No drone complete
    if (rowTouched) {
      if (!value?.trim()) {
        return this.createError({
          path: `drones[${index}].${keyName}`,
          // message: `${keyName.replace("_", " ")} is required`,
        });
      }
      return true;
    }

    // CASE 3: nothing touched anywhere → force index 0 only
    // const anyCompletePartially = isAnyDroneFilledPartially(drones);
    // if (index === 0 && !value?.trim() && !anyCompletePartially) {
    //   return this.createError({
    //     path: `drones[0].${keyName}`,
    //     // message: `${keyName.replace("_", " ")} is required`,
    //   });
    // }

    return true;
  };
}

export const droneSchema = Yup.object().shape({
  name: Yup.string()
    .default("")
    .transform((v) => v?.trim() || "")
    .required("Name is required"),

  display_id: Yup.string()
    .default("")
    .transform((v) => v?.trim() || "")
    .required("ID is required"),
  base_station_ip: Yup.string()
    .default("")
    .transform((v) => v?.trim() || "")
    .required("IP is required"),

  serverId: Yup.string()
    .transform((v) => v?.trim() || "")
    .default(""),

  drones: Yup.array()
    .default([setDroneData(), setDroneData(), setDroneData()])
    .of(
      Yup.object()
        .shape({
          droneId: Yup.string()
            .transform((v) => v?.trim() || "")
            .default(""),
          drone_ip: Yup.string()
            .transform((v) => v?.trim() || "")
            .default(""),
          device_id: Yup.string()
            .transform((v) => v?.trim() || "")
            .default(""),
          type: Yup.string()
            .transform((v) => v?.trim() || "")
            .default(""),
          id: Yup.string()
            .transform((v) => v?.trim() || "")
            .default("")
            .notRequired(),

          status: Yup.string()
            .transform((v) => v?.trim() || "")
            .default("AVAILABLE"),
        })
        .test(
          "drone-device-id-if-any-filled-single",
          "Device ID is required",
          droneFieldRequired("device_id"),
        )
        .test(
          "drone-type-if-any-filled-single",
          "Drone Type is required",
          droneFieldRequired("type"),
        )
        .test(
          "drone-ip-if-any-filled-single",
          "Drone IP is required",
          droneFieldRequired("drone_ip"),
        )
        .test(
          "drone-id-if-any-filled-single",
          "Drone ID is required",
          droneFieldRequired("droneId"),
        ),
    )
    .test(
      "unique-device-id",
      "Device ID must be unique for each drone",
      function (drones = []) {
        const seen = new Map();

        for (let i = 0; i < drones.length; i++) {
          const deviceId = drones[i]?.device_id?.trim();
          if (!deviceId) continue; // ignore empty rows

          if (seen.has(deviceId)) {
            return this.createError({
              path: `drones[${i}].device_id`,
              message: "Device ID must be unique",
            });
          }

          seen.set(deviceId, i);
        }
        //"Unique device ID check passed"

        return true;
      },
    ),
  doors: Yup.array()
    .default([])
    .of(
      Yup.object().shape({
        display_id: Yup.string()
          .transform((v) => v?.trim() || "")
          .default(""),
          // .required("Display ID is required"),
        ip: Yup.string()
          .transform((v) => v?.trim() || "")
          .default("")
          .required("IP is required"),
        isUpdate: Yup.string()
          .transform((v) => v?.trim() || "")
          .default(false)
          .notRequired(),
        device_id: Yup.string()
          .transform((v) => v?.trim() || "")
          .default("")
          .required("Device ID is required"),
        port: Yup.string()
          .transform((v) => v?.trim() || "")
          .default("")
          .required("Port is required")
          .test(
            "is-number",
            "Port must be a valid number",
            (value) => value !== "" && !isNaN(Number(value)),
          )
          .test("greater-than-zero", "Port must be greater than 0", (value) => {
            // 2️⃣ must be greater than 0
            const num = Number(value);
            return !isNaN(num) && num > 0;
          }),
        id: Yup.string()
          .transform((v) => v?.trim() || "")
          .default("")
          .notRequired(),
        status: Yup.string()
          .transform((v) => v?.trim() || "")
          .default("CLOSE")
          .required("Status is required"),
      }),
    ),
});
